jQuery(document).ready(function() {

  $.ajax({
    type: "GET",
    url: "/cart.js",
    dataType: "json",
    success: function (cartdata) {
      $.each( cartdata.items , function( i, val ) {
        $('.btn-orange[data-player="' + val.variant_id + '"], .add-player-btn[data-player="' + val.variant_id + '"]').addClass('button_check').css("pointer-events", "none");
        $('.switch-player input[type="checkbox"][data-id="' + val.variant_id + '"]').prop( "checked", true );
        $('.gift-slider__item[data-id="' + val.variant_id + '"] .slider-bought').show();
        $('.popup-give[data-id="' + val.variant_id + '"] .popup-btn').hide();
      });
    },
  });

  $('.add-player-btn').click(function(e){
    e.preventDefault();
    $('#popup-plan .close-btn').click();
    $('#gift-choice-player').click();
  });

  $('.popup-btn').click(function(e){
    e.preventDefault();
    var $this = $(this);
    var id = $this.data('id');
    if ( id ) {
      $('.popup-give[data-id="' + id + '"] .close-btn').click();
      $('.switch-player input[type="checkbox"][data-id="' + id + '"]').click();
      $('.popup-give[data-id="' + id + '"] .popup-btn').hide();
    }
  });

  $('.add-to-cart-box').click(function(e){
    e.preventDefault();
    var $this = $(this);
    var id = $this.data('id');
    $('.switch-player input[type="checkbox"][data-id="' + id + '"]').click();
  });

  $('#gift-choice-player').click(function(e){
    e.preventDefault();
    var $this = $(this);
    var player = $this.data('player');

    if ( player ) {
      $this.css("pointer-events", "none");
      $('.add-player-btn').css("pointer-events", "none");
      $('.preloader').show();
      var player_data = {
        "id": player,
        "quantity": 1
      };
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: player_data,
        dataType: "json",
        success: function (response) {
          $.ajax({
            type: "GET",
            url: "/cart.js",
            dataType: "json",
            success: function (cartdata) {
              //console.log(cartdata);
              $('.basket-counter').text(cartdata.item_count);
              $this.addClass("button_check");
              $('.add-player-btn').addClass("button_check");
              $(".preloader").hide();
            },
          });
        },
        error: function(xhr, status, error) {
          $this.css("pointer-events", "auto");
          $('.add-player-btn').css("pointer-events", "auto");
          $(".preloader").hide();
          alert(xhr.responseJSON.description);
        }
      });
    }
    
  });

  jQuery(document).on('change','.switch-player input[type="checkbox"]', function(e){
    var $this = $(this);
    var variantId = $this.data('id');
    if ( variantId ) {
      $('.preloader').show();
      if ($(this).is(":checked")) {
        var product_data = {
          "id": variantId,
          "quantity": 1
        };
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: product_data,
          dataType: "json",
          success: function (response) {
            $.ajax({
              type: "GET",
              url: "/cart.js",
              dataType: "json",
              success: function (cartdata) {
                //console.log(cartdata);
                $('.basket-counter').text(cartdata.item_count);
                $('.popup-give[data-id="' + variantId + '"] .popup-btn').hide();
                $('.gift-slider__item[data-id="' + variantId + '"] .slider-bought').show();
                $(".preloader").hide();
              },
            });
          },
          error: function(xhr, status, error) {
            $('.gift-slider__item[data-id="' + variantId + '"] .slider-bought').hide();
            $(".preloader").hide();
            alert(xhr.responseJSON.description);
          }
        });
      } else {
        var product_data = {
          "id": variantId,
          "quantity": 0
        };
        $.ajax({
          type: "POST",
          url: "/cart/change.js",
          data: product_data,
          dataType: "json",
          success: function (response) {
            $.ajax({
              type: "GET",
              url: "/cart.js",
              dataType: "json",
              success: function (cartdata) {
                //console.log(cartdata);
                $('.basket-counter').text(cartdata.item_count);
                $('.gift-slider__item[data-id="' + variantId + '"] .slider-bought').hide();
                $('.popup-give[data-id="' + variantId + '"] .popup-btn').show();
                $(".preloader").hide();
              },
            });
          },
          error: function(xhr, status, error) {
            $(".preloader").hide();
            alert(xhr.responseJSON.description);
          }
        });
      }
    }
  });
  
});